import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebaseConfig";
import { signOut } from "firebase/auth";
import CloudVoiceImage from "../../image/voiceProcessor-logo.png";
import Button from "./Button";

// Shared top navigation. Was previously duplicated inline in home.jsx and
// hero.jsx. `showUpload` hides the "Upload" link on the upload page itself.
export default function Navbar({ showUpload = true }) {
  const currentUser = auth.currentUser;
  const navigate = useNavigate();

  const logoutHandler = () => {
    signOut(auth)
      .then(() => {
        localStorage.removeItem("userCredential");
        navigate("/login");
      })
      .catch((error) => {
        console.error("logout failed", error);
      });
  };

  return (
    <nav
      className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-5 sm:px-6"
      aria-label="Global"
    >
      <a
        href="/"
        className="flex items-center"
        aria-label="Cloud Voice Processor home"
      >
        <img
          className="h-14 w-auto sm:h-16"
          src={CloudVoiceImage}
          alt="Voice Processor logo"
        />
      </a>
      <div className="flex items-center gap-2 sm:gap-3">
        {currentUser ? (
          <>
            {showUpload && (
              <Button href="/upload" variant="ghost">
                Upload
              </Button>
            )}
            <Button onClick={logoutHandler} variant="secondary">
              Sign out
            </Button>
          </>
        ) : (
          <>
            <Button href="/login" variant="ghost">
              Sign in
            </Button>
            <Button href="/signup" variant="primary">
              Sign up
            </Button>
          </>
        )}
      </div>
    </nav>
  );
}
